export default __webpack_public_path__ + "static/media/machine.e9898c72.jpg";